// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section{
    background:#215D88 !important;
    margin-top: 0px;
}
.footer-content{
    padding-top: 3rem;
    padding-bottom: 1rem;
}
ul{
    padding: 0;
}
ul li,p{
    list-style: none;
    margin: 0;
    padding-top: .5rem;
    padding-left: .25rem;
    font-weight: 400;
}
.footer-social-icon img{
    width: 17%;
    padding: 4px;
}
.policy{
    margin-top: 3rem;
    border-bottom: 1px solid white;
}
.policy p{
    font-weight: 600;
    cursor: pointer;
}
.quick{
    margin-top: .5rem;
    margin-bottom: 1.5rem;
}
.newsletter{
    text-align: center;
    position: relative;
    background: white ;
    color: #17c7fc !important;
    border-radius: 82px;
    padding: 1.25rem 1rem;
    bottom: 45px;
    /* margin-top: 45px; */
    border: 2px solid #17c7fc;
    margin-bottom: -25px;
}
/* .newsletter h3{
    border-left:4px solid #FFFFFF;
    padding-left: 1rem;
    margin-bottom: 0;
} */
.newsletter h3::after {
    content: "";
    position: absolute;
    left: 50px;
    height: 35px;
    top: 10px;
    width: 5px;
    background-color: #17c7fc;
  }
  /* .form-group label {
    font-size: 16px;
    font-weight: 800;
    color: #0b2238;
}
.form-control {
    background-color: #f7f8fa;
    border-color: transparent;
}
.form-control:focus {
    background-color: #ffffff;
    box-shadow: none;
} */
/* .form-group input{
    height: 55px;
    padding-left: 1.25rem;
    color: #0b2238 !important;
    font-size: 16px;
    border-radius: 8px;
    font-weight: 500;
    border-color: #215d88b0;
    transition: 0.3s !important;
} */
input::placeholder{
    font-size: 1.75rem;
    color: #17c7fc;
    font-family: 'Montserrat';
}
input,input:focus{
    width: 90%;
    position: relative;
    left: 75px;
    background: transparent;
    border: none;
    height: 55px;
    padding-left: 1.25rem;
    color: #17c7fc !important;
    box-shadow: none;
    font-size: 22px;
    padding-top: 10px;
}
.modal{
    overflow: scroll;
    display: block;
    background-color: #2a6f9924;
    -webkit-backdrop-filter: blur(1px);
            backdrop-filter: blur(1px);
}
.modal-content{
    border-radius: 22px;
    border-color: #215d88;
}
p:focus{
outline: none;
}
@media screen and (max-width:768px){
    .footer-section{
        margin-top: 2px;
    }
    .footer-content{
        padding-top: 1rem;
        padding-bottom: .5rem;
    }
    .policy{
        margin-top: 1.5rem;
        padding-bottom: 1rem;
    }
    .policy figure {
        margin: 0rem;
    }
    .quick{
        margin-top: 1.5rem;
        margin-bottom: 0rem;
    }
    .policy p , .policy figure{
        text-align: center;
    }
    .footer-social-icon img{
        width: 15%;
        margin-top: .5rem;
    }
    .newsletter{
        padding: .5rem;
        bottom: 20px;
        margin-top: 0px;
        margin-bottom: -25px;
        /* padding-bottom: .55rem; */
    }
    input,input:focus{
        left: 10px;
        font-size: 16px;
        height: 30px;
        padding-top: 4px;
    }
    .newsletter h3{
        font-size: 75%;
    }
    .newsletter h3::after{
        left: 7.5%;
        height: 20px;
        top: 5px;
        width: 3px;
    }
    input::placeholder{
        font-size: .75rem;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;AACxB;AACA;;;;GAIG;AACH;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,UAAU;IACV,yBAAyB;EAC3B;EACA;;;;;;;;;;;;GAYC;AACH;;;;;;;;;GASG;AACH;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,kCAA0B;YAA1B,0BAA0B;AAC9B;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;AACA,aAAa;AACb;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,YAAY;QACZ,eAAe;QACf,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,UAAU;QACV,YAAY;QACZ,QAAQ;QACR,UAAU;IACd;IACA;QACI,iBAAiB;IACrB;;AAEJ","sourcesContent":[".footer-section{\n    background:#215D88 !important;\n    margin-top: 0px;\n}\n.footer-content{\n    padding-top: 3rem;\n    padding-bottom: 1rem;\n}\nul{\n    padding: 0;\n}\nul li,p{\n    list-style: none;\n    margin: 0;\n    padding-top: .5rem;\n    padding-left: .25rem;\n    font-weight: 400;\n}\n.footer-social-icon img{\n    width: 17%;\n    padding: 4px;\n}\n.policy{\n    margin-top: 3rem;\n    border-bottom: 1px solid white;\n}\n.policy p{\n    font-weight: 600;\n    cursor: pointer;\n}\n.quick{\n    margin-top: .5rem;\n    margin-bottom: 1.5rem;\n}\n.newsletter{\n    text-align: center;\n    position: relative;\n    background: white ;\n    color: #17c7fc !important;\n    border-radius: 82px;\n    padding: 1.25rem 1rem;\n    bottom: 45px;\n    /* margin-top: 45px; */\n    border: 2px solid #17c7fc;\n    margin-bottom: -25px;\n}\n/* .newsletter h3{\n    border-left:4px solid #FFFFFF;\n    padding-left: 1rem;\n    margin-bottom: 0;\n} */\n.newsletter h3::after {\n    content: \"\";\n    position: absolute;\n    left: 50px;\n    height: 35px;\n    top: 10px;\n    width: 5px;\n    background-color: #17c7fc;\n  }\n  /* .form-group label {\n    font-size: 16px;\n    font-weight: 800;\n    color: #0b2238;\n}\n.form-control {\n    background-color: #f7f8fa;\n    border-color: transparent;\n}\n.form-control:focus {\n    background-color: #ffffff;\n    box-shadow: none;\n} */\n/* .form-group input{\n    height: 55px;\n    padding-left: 1.25rem;\n    color: #0b2238 !important;\n    font-size: 16px;\n    border-radius: 8px;\n    font-weight: 500;\n    border-color: #215d88b0;\n    transition: 0.3s !important;\n} */\ninput::placeholder{\n    font-size: 1.75rem;\n    color: #17c7fc;\n    font-family: 'Montserrat';\n}\ninput,input:focus{\n    width: 90%;\n    position: relative;\n    left: 75px;\n    background: transparent;\n    border: none;\n    height: 55px;\n    padding-left: 1.25rem;\n    color: #17c7fc !important;\n    box-shadow: none;\n    font-size: 22px;\n    padding-top: 10px;\n}\n.modal{\n    overflow: scroll;\n    display: block;\n    background-color: #2a6f9924;\n    backdrop-filter: blur(1px);\n}\n.modal-content{\n    border-radius: 22px;\n    border-color: #215d88;\n}\np:focus{\noutline: none;\n}\n@media screen and (max-width:768px){\n    .footer-section{\n        margin-top: 2px;\n    }\n    .footer-content{\n        padding-top: 1rem;\n        padding-bottom: .5rem;\n    }\n    .policy{\n        margin-top: 1.5rem;\n        padding-bottom: 1rem;\n    }\n    .policy figure {\n        margin: 0rem;\n    }\n    .quick{\n        margin-top: 1.5rem;\n        margin-bottom: 0rem;\n    }\n    .policy p , .policy figure{\n        text-align: center;\n    }\n    .footer-social-icon img{\n        width: 15%;\n        margin-top: .5rem;\n    }\n    .newsletter{\n        padding: .5rem;\n        bottom: 20px;\n        margin-top: 0px;\n        margin-bottom: -25px;\n        /* padding-bottom: .55rem; */\n    }\n    input,input:focus{\n        left: 10px;\n        font-size: 16px;\n        height: 30px;\n        padding-top: 4px;\n    }\n    .newsletter h3{\n        font-size: 75%;\n    }\n    .newsletter h3::after{\n        left: 7.5%;\n        height: 20px;\n        top: 5px;\n        width: 3px;\n    }\n    input::placeholder{\n        font-size: .75rem;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
